// extracted by mini-css-extract-plugin
module.exports = {"form-container":"SignIn_form-container__38pHI","form":"SignIn_form__3P3gu","error-message":"SignIn_error-message__1fbLV"};